module.exports = __webpack_public_path__ + "static/media/upload.469634b7.svg";